<nav class="nhsuk-contents-list scwcsu" role="navigation" aria-label="Child details sections">
  <ul class="nhsuk-contents-list__list">
    <li>
      <a
        class="list-item-link"
        [ngClass]="{ 'active-link': isUrlMatch(['notifications']) }"
        routerLink="/admin/notifications"
        (click)="removeFocus($event)"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        Notifications
      </a>
    </li>
    <li>
      <a
        class="list-item-link"
        [ngClass]="{
          'active-link': isUrlMatch([
            'organisations-mapping',
            'organisations-mapping/add',
            'organisations-mapping/edit',
          ]),
        }"
        routerLink="/admin/organisations-mapping"
        (click)="removeFocus($event)"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        Organisations Mapping
      </a>
    </li>
    <li>
      <a
        class="list-item-link"
        [ngClass]="{ 'active-link': isUrlMatch(['whats-new', 'whats-new/create']) }"
        routerLink="/admin/whats-new"
        (click)="removeFocus($event)"
      >
        <svg
          class="nhsuk-icon nhsuk-icon__chevron-right"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            d="M15.5 12a1 1 0 0 1-.29.71l-5 5a1 1 0 0 1-1.42-1.42l4.3-4.29-4.3-4.29a1 1 0 0 1 1.42-1.42l5 5a1 1 0 0 1 .29.71z"
          ></path>
        </svg>
        What's new
      </a>
    </li>
  </ul>
</nav>
